exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span>p[data-v-06b78208]{font-size:20px}p[data-v-06b78208]{font-family:Nunito Sans,sans-serif;font-size:45px;font-weight:500}ul>li[data-v-06b78208]{font-size:25px;list-style-type:square}#shadow[data-v-06b78208]{border-radius:5px;-webkit-box-shadow:0 2px 30px 10px rgba(0,0,0,.53);-moz-box-shadow:0 2px 30px 10px rgba(0,0,0,.53);box-shadow:0 2px 30px 10px rgba(0,0,0,.53)}.before-enter[data-v-06b78208]{opacity:0;transform:scale(0);transition:all .5s ease-in}.enter[data-v-06b78208]{opacity:1;transform:scale(1)}@media only screen and (max-width:360px){.card-title[data-v-06b78208]{font-size:41px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06b78208","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/About.vue
// module id = 174
// module chunks = 0